<template>
  <div
    :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }"
    id="offers"
  >
    <header-o :model="headerData"></header-o>
    <div class="margin-vertical-10 offer-card" style="margin-top: -180px">
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          minHeight: '80vh',
          borderRadius: '10px'
        }"
        class="bg-light bottom-radius-5 padding-horizontal-15 pos-rel box-shadow margin-bottom-10"
        v-if="!isEmpty(offerData)"
      >
        <div
          v-if="
            offerData.theme === 'default' &&
              partnerID !== '7a09ca9802cbe1556d3e'
          "
        >
          <!--  -->
          <div
            class="margin-bottom-20 font-bold text-semi-large padding-vertical-20"
          >
            {{ stripHTML(offerData.name) }}
          </div>
          <div
            class="margin-bottom-20 padding-vertical-20 word-break"
            style="font-weight: 500 !important;"
            v-html="replaceNewLine(offerData.stamp_rule.how_to)"
          ></div>
        </div>

        <div
          v-if="
            offerData.theme === 'banner' && partnerID === '7a09ca9802cbe1556d3e'
          "
        >
          <!--  -->
          <div
            class="margin-bottom-20 font-bold text-semi-large padding-vertical-20"
          >
            {{ stripHTML(offerData.name) }}
          </div>
          <div
            class="margin-bottom-20 padding-vertical-20 word-break"
            style="font-weight: 500 !important;"
            v-html="replaceNewLine(offerData.stamp_rule.how_to)"
          ></div>
        </div>

        <div
          v-if="
            offerData.theme === 'banner' && partnerID !== '7a09ca9802cbe1556d3e'
          "
        >
          <img class="w85" :src="offerData.campaign_banner1" />
        </div>

        <div v-if="userOffers.length > 0" class="full-width text-center">
          <h5 class="font-bold">Stamp Rewards</h5>
        </div>
        <div class="stamp-detail-wrapper" id="scratch-card-wrapper">
          <div v-if="userOffers.length > 0" class="sc-stamp-container">
            <div v-for="sc in userOffers">
              <div
                @click="showScratchCard(sc)"
                :style="{ background: bgTheme }"
                class="stamp-scratch-card sc-wrap pos-rel margin-bottom-15 radius-10"
              >
                <img class="full-width opc-25" src="@/assets/sc-bg.svg" />
                <div
                  class="radius50 pos-abs pos-center-ver pos-center-hor align-hor center-ver center-hor"
                  style="height: 60px; width: 60px;"
                  :style="{ background: darkerBg }"
                >
                  <img class="w25 opc-80" src="@/assets/medal-white.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="stamps.length > 0" class="full-width text-center">
          <h5 class="font-bold">Collect All and Win</h5>
        </div>
        <div
          class="stamps-wrapper"
          v-if="stamps.length > 0"
          :style="{
            'justify-content': stamps.length % 2 == 0 ? 'center' : ' flex-start'
          }"
        >
          <div
            v-for="stamp in stamps"
            style="position: relative; text-align: center;"
          >
            <img
              :src="stamp.logo"
              :class="[
                stamp.logo_disabled || stamp.count == 0 ? 'disabled' : ''
              ]"
              class="stamp-img"
              :style="[
                width > 391
                  ? { width: '95px' }
                  : width > 359
                  ? { width: '85px' }
                  : { width: '78px' }
              ]"
            />
            <div
              class="stamp-count"
              :style="{ border: `${bgTheme} 1px solid` }"
            >
              {{ stamp.count }}
            </div>
          </div>
        </div>

        <div
          class="full-width stamp-action-button-group"
          v-if="offerData.gifting_enabled"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
            class="stamp-action-btn"
            @click="toggle()"
          >
            Gift
          </div>
          <div
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
            class="stamp-action-btn"
            @click="toggle()"
          >
            Request
          </div>
        </div>
        <div class="margin-bottom-10 stamp-detail-wrapper">
          <!-- <div class="detail-box w85">
            <div class="w15">
              <img src="../assets/gift-box.svg"/>
            </div>
            <div class="w85">
              <div class="margin-bottom-20 font-bold text-semi-large padding-vertical-20">{{stripHTML(offerData.name)}}</div>
              <div class="margin-bottom-20 padding-vertical-20 word-break" v-html="replaceNewLine(offerData.stamp_rule.how_to)"></div>
            </div>
          </div> -->

          <div
            class="invite-earn-content margin-bottom-30 pos-rel w85"
            v-if="offerData.stamp_actions.length > 0"
          >
            <!-- <div v-if="offerData.stamp_actions.length>0" class="full-width text-center"><h5 class="font-bold">Challenges</h5></div> -->
            <div v-for="action in offerData.stamp_actions">
              <div
                style="display:flex; flex-direction:row; justify-content:start;align-items:center; cursor:pointer"
                @click="openChallenge(action)"
              >
                <div class="w20">
                  <div class="" style="width:36px;">
                    <img :src="action.logo" style="width: 30px;" />
                  </div>
                </div>
                <div class="w80 text-left">
                  <div v-html="action.what_to" class="what-to"></div>
                  <!-- <div v-html="action.how_to"></div> -->
                </div>
                <div>
                  <img src="../assets/right-arrow.svg" style="width: 10px;" />
                </div>
              </div>
            </div>
          </div>

          <div class="offer-details justify-text padding-vertical-20">
            <!-- v-if="offerData.theme === 'default'"-->
            <div class="text-large font-bold margin-bottom-20">Rules</div>
            <div
              class="text-left word-break"
              v-if="offerData.game_rules.length > 0"
            >
              <div
                class="margin-bottom-10"
                style="font-weight: 500 !important;"
                v-html="offerData.game_rules"
              ></div>
            </div>
            <div v-else class="text-left word-break">
              <div class="margin-bottom-10" v-html="offerData.details"></div>
            </div>
          </div>

          <div
            class="offer-details"
            v-if="
              offerData.theme === 'banner' &&
                partnerID !== '7a09ca9802cbe1556d3e'
            "
          >
            <img class="w85" :src="offerData.campaign_banner2" />
          </div>
        </div>

        <div
          id="copied-toast"
          class="font-bold pos-fixed pos-center-hor pull-down"
          style="width: 180px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none;"
        >
          Complete Task to collect Stamps
        </div>
      </div>

      <div v-if="isEmpty(offerData)">
        <div class="bg-light radius-5 padding-20 margin-bottom-10 pos-rel">
          <div class="wrapper align-hor center-ver margin-bottom-5">
            <div class="wrapper center-ver">
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w85"
              ></div>
            </div>

            <div class="wrapper center-ver">
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w85"
              ></div>
            </div>

            <div class="wrapper center-ver">
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div class="comment animate bg-light-grey w85"></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w85"
              ></div>
            </div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10">
            <div class="wrapper margin-bottom-20">
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-20">
            <div
              class="align-hor center-ver space-between bottom-border padding-bottom-10"
            >
              <div class="w20" v-for="$i in 3">
                <div class="wrapper align-hor center-hor">
                  <div
                    class="comment animate bg-light-grey margin-bottom-5 w20 margin-right-5"
                  ></div>
                  <div
                    class="comment animate bg-light-grey margin-bottom-5 w80"
                  ></div>
                </div>
              </div>
            </div>
            <div
              class="wrapper align-hor center-ver space-between bottom-border padding-horizontal-20"
              v-for="$i in 3"
            >
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10" v-for="$1 in 2">
            <div class="wrapper margin-bottom-20">
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        :maskClosable="true"
        :zIndex="1002"
        @close="toggle()"
        :closeable="true"
        :header-text="'Terms & Conditions'"
      >
        <div v-if="open">
          <!--  <div v-html="offerData.tnc"></div>
          <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 5px">
            <button @click="acceptTnc" class="accept-btn">Accept</button>
          </div> -->
          <!-- <div class="font-bold text-large margin-bottom-10 text-uppercase">Invite now</div>
          <div class="share align-hor center-ver center-hor">
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'wa')">
              <img class="medium-icon margin-right-5" src="@/assets/share/whatsup.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'fb')">
              <img class="medium-icon margin-right-5" src="@/assets/share/fb.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'tw')">
              <img class="medium-icon margin-right-5" src="@/assets/share/tiw.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'gm')">
              <img class="medium-icon margin-right-5" src="@/assets/share/gmail.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'cp')">
              <img class="medium-icon margin-right-5" src="@/assets/share/copy.png">
            </div>
          </div>  -->
          <div class="font-bold text-large margin-bottom-10 text-uppercase">
            Invite now
          </div>
          <div class="share align-hor center-ver center-hor">
            <div
              class="share-action-button show-in-mobile pointer"
              @click="getShareMsg(offerData.id, 'wa')"
            >
              <img
                class="medium-icon margin-right-5"
                src="@/assets/share/whatsup.png"
              />
            </div>
            <div
              class="share-action-button show-in-mobile pointer"
              @click="getShareMsg(offerData.id, 'fb')"
            >
              <img
                class="medium-icon margin-right-5"
                src="@/assets/share/fb.png"
              />
            </div>
            <div
              class="share-action-button show-in-mobile pointer"
              @click="getShareMsg(offerData.id, 'tw')"
            >
              <img
                class="medium-icon margin-right-5"
                src="@/assets/share/tiw.png"
              />
            </div>
            <div
              class="share-action-button show-in-mobile pointer"
              @click="getShareMsg(offerData.id, 'gm')"
            >
              <img
                class="medium-icon margin-right-5"
                src="@/assets/share/gmail.png"
              />
            </div>
            <div
              class="share-action-button show-in-mobile pointer"
              @click="getShareMsg(offerData.id, 'cp')"
            >
              <img
                class="medium-icon margin-right-5"
                src="@/assets/share/copy.png"
              />
            </div>
          </div>
        </div>
      </Drawer>

      <!-- <div class="overlay" v-if="scratchCard" style="height: 100vh;" @click="hideScratchCard(scratchCard)">
                <div class="text-light" style="height: 100vh;">
                  <div style="display: flex; justify-content: end; width: 100%">
                    <img src="@/assets/close.svg" class="w10 pointer" v-on:click="hideScratchCard(scratchCard)" style="padding:10px">
                  </div>
                  <div class="align-ver center-ver center-hor" style="height: 90%;">
                    <div class="offer-desc margin-bottom-20">{{scratchCard.earned_for}}</div>
                    <scratch-card :key="renderCount"
                                  :cardWidth="cardWidth"
                                  :cardHeight="cardHeight"
                                  :finishPercent="finishPercent"
                                  :imageBg="bgTheme"
                                  :imageUrl="imageUrl"
                                  :imageDarkBg="darkerBg"
                                  :brushUrl="brushUrl"
                                  :forceReveal="forceReveal"
                                  @complete="onComplete(scratchCard)"
                                  @click.stop.prevent
                                  v-if="!scratchCard.is_scratched">
                      <div class="" @click.stop.prevent>
                        <img class="w50 opc-80" :src="scratchCard.reward_logo" >
                      </div>
                      <div>
                        <div class="text-center text-grey text-extra-large font-bold">{{scratchCard.reward_title}}</div>
                      </div>
                    </scratch-card>
                    <div class="card-content bg-light radius-30" v-else @click.stop.prevent>
                        <div class="margin-bottom-20">
                          <img class="w50 opc-80" :src="scratchCard.reward_logo">
                        </div>
                        <div class="text-center text-grey text-extra-large font-bold">{{scratchCard.reward_title}}</div>
                    </div>

                    <div class="offer-details text-center margin-horizontal-30">
                      <div class="margin-bottom-5">Ref Number: #{{scratchCard.ref}}</div>
                      <div v-if="scratchCard.scratched_on">Earned on: {{formattedDate(scratchCard.scratched_on, true)}}</div>
                      <div v-else>Earned on:{{formattedDate(scratchCard.created_at,true)}}</div>
                    </div>

                  </div>
                </div>
              </div>


              <div style="z-index: 2000000;
                background-color: rgba(0, 0, 0, 0.8);
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;bottom: 0; display: flex;"
                v-if="scPending" class="align-ver center-ver center-hor" id="sc_won_fullscreen_popup">
                  <div style="display: flex; width: 100%; justify-content: end; align-items: center; padding-right: 10px">
                    <img src="@/assets/close.svg" class="w10 pointer" v-on:click="hidePopup()" style="position: absolute; right: 20px"/>
                  </div>
                  <div class="" style="color: white; font-size: 22px; margin-bottom: 25px;">Congratulations!</div>
                  <div class="text-light" style="margin-bottom: 50px">You WON Scratch Card!</div>

                  <div :style="{background: bgTheme}" class="margin-bottom-15 pos-rel" style="width: 55vw; height: 55vw; border-radius: 20px;" @click="hidePopup(); redirectTo('rewards')">
                    <img class="full-width opc-25" src="@/assets/sc-bg.svg">
                    <div class="radius50 pos-center-ver pos-abs pos-center-hor align-hor center-ver center-hor" style="height: 60px; width: 60px;" :style="{background: darkerBg}">
                    <img class="w40 opc-80" src="@/assets/medal-white.svg">
                  </div>
                  </div>
               <div class="text-center" style="border: 1px solid white; border-radius: 20px; height: 20px; padding: 5px 25px 5px 25px; color: white; line-height: 20px; margin: 40px 0; font-size: 14px; cursor: pointer;" @click="hidePopup(); redirectTo('rewards')">
                          CLAIM
                    </div>

              </div>  -->
    </div>
    <div class="overlay" v-if="scratchCard" style="height: 100vh;">
      <!-- @click="hideScratchCard(scratchCard)" -->
      <div class="text-light" style="height: 100vh;">
        <div style="display: flex; justify-content: end; width: 100%">
          <img
            src="@/assets/close.svg"
            class="w10 pointer"
            v-on:click="hideScratchCard(scratchCard)"
            style="padding:10px"
          />
        </div>
        <div class="align-ver center-ver center-hor" style="height: 90%;">
          <div class="offer-desc margin-bottom-20">
            {{ scratchCard.earned_for }}
          </div>
          <scratch-card
            :key="renderCount"
            :cardWidth="cardWidth"
            :cardHeight="cardHeight"
            :finishPercent="finishPercent"
            :imageBg="bgTheme"
            :imageUrl="imageUrl"
            :imageDarkBg="darkerBg"
            :brushUrl="brushUrl"
            :forceReveal="forceReveal"
            @complete="onComplete(scratchCard)"
            @click.stop.prevent
            v-if="!scratchCard.is_scratched"
          >
            <div class="" @click.stop.prevent>
              <img class="w50 opc-80" :src="scratchCard.reward_logo" />
            </div>
            <div>
              <div class="text-center text-grey text-extra-large font-bold">
                {{ scratchCard.reward_title }}
              </div>
            </div>
          </scratch-card>
          <div
            class="card-content bg-light radius-30"
            v-else
            @click.stop.prevent
          >
            <div class="margin-bottom-20">
              <img class="w50 opc-80" :src="scratchCard.reward_logo" />
            </div>
            <div class="text-center text-grey text-extra-large font-bold">
              {{ scratchCard.reward_title }}
            </div>
          </div>

          <div class="offer-details text-center margin-horizontal-30">
            <div class="margin-bottom-5">
              Ref Number: #{{ scratchCard.ref }}
            </div>
            <div v-if="scratchCard.scratched_on">
              Earned on: {{ formattedDate(scratchCard.scratched_on, true) }}
            </div>
            <div v-else>
              Earned on:{{ formattedDate(scratchCard.created_at, true) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="z-index: 2000000;
                background-color: rgba(0, 0, 0, 0.8);
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;bottom: 0; display: flex;"
      v-if="scPending"
      class="align-ver center-ver center-hor"
      id="sc_won_fullscreen_popup"
    >
      <div
        style="display: flex; width: 100%; justify-content: end; align-items: center; padding-right: 10px"
      >
        <img
          src="@/assets/close.svg"
          class="w10 pointer"
          v-on:click="hidePopup()"
          style="position: absolute; right: 20px"
        />
      </div>
      <div class="" style="color: white; font-size: 22px; margin-bottom: 25px;">
        Congratulations!
      </div>
      <div class="text-light" style="margin-bottom: 50px">
        You WON Scratch Card!
      </div>

      <div
        :style="{ background: bgTheme }"
        class="margin-bottom-15 pos-rel"
        style="width: 55vw; height: 55vw; border-radius: 20px;"
        @click="
          hidePopup();
          redirectTo('rewards');
        "
      >
        <img class="full-width opc-25" src="@/assets/sc-bg.svg" />
        <div
          class="radius50 pos-center-ver pos-abs pos-center-hor align-hor center-ver center-hor"
          style="height: 60px; width: 60px;"
          :style="{ background: darkerBg }"
        >
          <img class="w40 opc-80" src="@/assets/medal-white.svg" />
        </div>
      </div>
      <div
        class="text-center"
        style="border: 1px solid white; border-radius: 20px; height: 20px; padding: 5px 25px 5px 25px; color: white; line-height: 20px; margin: 40px 0; font-size: 14px; cursor: pointer;"
        @click="
          hidePopup();
          redirectTo('rewards');
        "
      >
        CLAIM
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import Milestone from "@/components/milestone";
import Drawer from "@/components/drawer";
import ScratchCard from "@/components/scratch-card";
import BRUSH from "@/assets/brush.png";
import SCBG from "@/assets/sc-bg-empty-circle.svg";
import SCBG1 from "@/assets/sc-bg.png";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    milestone: Milestone,
    "scratch-card": ScratchCard,
    "scratch-card": ScratchCard,
    Drawer
  },
  data() {
    return {
      headerData: {
        onlyHeader: true
      },
      offerData: {},
      currentOffer: null,
      userOffers: [],
      stamps: [],
      hasReferee: false,
      open: false,
      windowWidth: window.innerWidth,
      renderCount: 0,
      cardWidth: 200,
      cardHeight: 200,
      finishPercent: 60,
      brushUrl: BRUSH,
      sc_pending: false,
      scBgUrl: SCBG,
      imageUrl: SCBG1,
      imageUrl: SCBG1,
      forceReveal: false,
      placeholder: true,
      is_shimmer: true,
      refer_code: null,
      show_see_offer: false,
      windowWidth: window.innerWidth,
      renderCount: 0,
      cardWidth: 200,
      cardHeight: 200,
      finishPercent: 60,
      brushUrl: BRUSH,
      sc_pending: false,
      scBgUrl: SCBG,
      imageUrl: SCBG1,
      imageUrl: SCBG1,
      forceReveal: false,
      placeholder: true,
      is_shimmer: true,
      refer_code: null,
      show_see_offer: false,
      partnerID: ""
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },

    isInviteEarn: function() {
      return this.is_invite_earn;
    },
    isCheckIn: function() {
      return this.is_checkin;
    },
    isGameZone: function() {
      return this.is_game_zone;
    },
    scratchCard: function() {
      return this.currentOffer;
    },
    scPending: function() {
      return this.sc_pending && this.$store.state.show_sc;
    },
    width: function() {
      return this.windowWidth;
    },
    scratchCard: function() {
      return this.currentOffer;
    },
    scPending: function() {
      return this.sc_pending && this.$store.state.show_sc;
    },
    width: function() {
      return this.windowWidth;
    }
  },
  methods: {
    getOfferDetails(id) {
      var self = this;
      var url = this.$store.getters.flyyDomain + "/v1/users/stamps";
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers,
          params: {
            page: this.page
          }
        })
        .then(resp => {
          if (resp.data.success) {
            this.offerData = resp.data;
            this.offerData.user_offers.forEach(gift => {
              gift.show_sc = false;
            });
            this.userOffers = this.offerData.user_offers;
            this.stamps = this.offerData.stamps;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestStamp() {
      let url = this.$store.getters.flyyDomain + "/request_stamp";
      let headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers
        })
        .then(resp => {
          console.log(resp);
        });
    },
    onComplete(uo) {
      console.log(uo);
      var ref = uo.ref;
      var self = this;
      var url = this.$store.getters.flyyDomain + "/scratch_user_offer/" + ref;
      var headers = this.$store.getters.headers;

      var options = {
        headers: headers
      };

      axios
        .put(
          url,
          {
            mode: "no-cors"
          },
          options
        )
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            var user_offer = data.user_offer;
            uo.is_scratched = user_offer.is_scratched;
            //this.userOffers
            var index = this.userOffers
              .map(x => {
                return x.id;
              })
              .indexOf(uo.id);
            this.userOffers.splice(index, 1);
            this.getStampCount(this.offerData.id);
            self.getBasicAppInfo();
          } else {
            console.log("Error fetching the user offers");
          }
        })
        .catch(error => {
          console.log("Catch block", error);
        });
    },
    getStampCount(id) {
      var url = this.$store.getters.flyyDomain + `/v1/users/stamps_count/${id}`;
      var headers = this.$store.getters.headers;

      var options = {
        headers: headers
      };

      axios
        .get(url, options)
        .then(resp => {
          if (resp.status == 200) {
            let count_obj = resp.data.stamps_with_count;
            this.stamps.forEach(stamp => {
              stamp.count = count_obj[stamp.id];
            });
          }
        })
        .catch(error => {
          console.log("Catch block", error);
        });
    },
    getStampCount(id) {
      var url = this.$store.getters.flyyDomain + `/v1/users/stamps_count/${id}`;
      var headers = this.$store.getters.headers;

      var options = {
        headers: headers
      };

      axios.get(url, options).then(resp => {
        if (resp.status == 200) {
          console.log(resp);
          let count_obj = resp.data.stamps_with_count;
          console.log(count_obj);
          this.stamps.forEach(stamp => {
            stamp.count = count_obj[stamp.id];
          });

          console.log(this.allAreEqual(count_obj));

          if (this.allAreEqual(count_obj)) {
            this.checkPendingSC();
          }
        }
      });
    },
    showScratchCard(uo) {
      console.log(uo, "sc clicked");
      //uo.show_sc = true;
      /* this.userOffers.find((sc) => sc.id == uo.id).show_sc = true;
        console.log(this.userOffers); */
      this.currentOffer = uo;
    },
    hideScratchCard(uo) {
      console.log(uo, "sc clicked");
      uo.show_sc = false;
      this.currentOffer = null;
    },
    toggle() {
      this.open = !this.open;
      this.requestStamp();
    },
    closeAndAccept() {
      this.open = !this.open;
    },
    hidePopup() {
      this.sc_pending = false;
      this.$store.state.show_sc = false;
    },
    openChallenge(action) {
      if (window.webkit) {
        window.webkit.messageHandlers.handleMessage.postMessage(action);
      } else {
        window.parent.postMessage(action, "*");
      }

      document.getElementById("copied-toast").style.display = "block";
      setTimeout(function() {
        document.getElementById("copied-toast").style.display = "none";
      }, 2000);
    },
    allAreEqual(obj) {
      return new Set(Object.values(obj)).size >= 1;
    },
    checkPendingSC() {
      // console.log("created");
      var url =
        this.$store.getters.flyyDomain.replace("/api", "") +
        `/v1/${this.$store.state.partner}/partner_user/pending_rewards`;
      var headers = this.$store.getters.headers;

      var options = {
        headers: headers
      };

      axios
        .post(
          url,
          {
            mode: "no-cors"
          },
          options
        )
        .then(resp => {
          if (resp.status == 200) {
            this.sc_pending = resp.data.success;
          } else {
            console.log("Error fetching the pending sc data");
          }
        })
        .catch(error => {
          console.log(error);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  beforeMount() {
    this.$store.state.headTitle = "Stamp Campaign";
    this.getOfferDetails();
  },
  beforeMount() {
    this.$store.state.headTitle = "Stamp Campaign";
    this.getOfferDetails();
  },
  created() {
    /* /* if(!this.isEmpty(this.$route.params)) {
      this.getOfferDetails(this.$route.params.id);
    } */

    var element = document.scrollingElement || document.documentElement;
    element.addEventListener("wheel", this.transformScroll);

    var element = document.scrollingElement || document.documentElement;
    element.addEventListener("wheel", this.transformScroll);

    this.partnerID = this.$store.state.requestHeaders["X-Key"];
  }
};
</script>
<style>
.stamps-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 0 0 31.333333%;
  margin: 0 1rem;
}

.stamp-img {
  /* width: 84px; */
  border-radius: 10px;
  margin: 5px 6px;
}

.stamp-count {
  position: absolute;
  right: -4px;
  bottom: -2px;
  padding: 2px 7px;
  border-radius: 50px;
  border: var(--bg-color) 1px solid;
  font-weight: bold !important;
}

.stamp-detail-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.detail-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.disabled {
  transition: all 0.3s ease;
  opacity: 0.66;
}

.stamp-action-button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

p {
  margin: 1rem 0 !important;
}

.stamp-action-btn {
  background: var(--bg-color);
  color: #ffffff;
  font-size: 18px;
  padding: 5px 15px;
  margin: 0 4px;
  border-radius: 30px;
  width: 70px;
}

.sc-stamp-container {
  display: flex;
  overflow-x: scroll;
  width: 90vw;
  justify-content: start;
  align-items: flex-start;
  scrollbar-width: none;
}

.stamp-scratch-card {
  width: 90px;
  height: 90px;
  margin-left: 12px;
}
.currency-type {
  position: absolute;
  top: 10px;
  right: 10px;
}

.check-mark {
  display: inline-block;
  transform: rotate(45deg);
  width: 5px;
  height: 13px;
  border-bottom: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
}
.padding-bottom-60 {
  padding-bottom: 60px;
}

.accept-btn {
  padding: 5px 23px;
  border-radius: 7px;
  color: #ffffff;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  background: var(--bg-color);
}

.sc-wrap {
}
.scratched-reward-icon {
  width: 70px;
}
.card-content {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.challenge-img {
  border-radius: 90px;
  background: #80808059;
  padding: 5px;
}

.sc-wrap {
}
.scratched-reward-icon {
  width: 70px;
}
.card-content {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.challenge-img {
  border-radius: 90px;
  background: #80808059;
  padding: 5px;
}
</style>
